import { render, staticRenderFns } from "./StatisticsChannel.vue?vue&type=template&id=493fd5d3&scoped=true&"
import script from "./StatisticsChannel.vue?vue&type=script&lang=js&"
export * from "./StatisticsChannel.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsChannel.vue?vue&type=style&index=0&id=493fd5d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493fd5d3",
  null
  
)

export default component.exports